<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            locale="de"
            multi-sort
            no-data-text="Es liegen noch keine Daten vor."
            no-results-text="Es wurden keine Ergebnisse gefunden."
            loading-text="Lädt..."
            :footer-props="{
                            itemsPerPageText: 'Einträge pro Seite',
                            itemsPerPageOptions: [10,25,50,100, -1],
                            itemsPerPageAllText: 'Alle'
                        }"

    >
        <template v-slot:item.action="{ item }">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs}">
                    <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            :to="{ name: 'EmployeeInterviewsEmployeesShow', params: { id: item.id }, query: {type: type}}"
                            exact
                    >
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </template>
                <span>Ansicht</span>
            </v-tooltip>
        </template>

        <template v-slot:item.last_interview_at="{ item }">
            <span v-if="item.last_interview_at">{{item.last_interview_at}}</span>
            <span v-else>-</span>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        props: ['headers', 'search', 'items', 'type', 'loading'],
    }
</script>

<style scoped>

</style>
